import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'
import { checkTypeCardActivity } from '@/utils/checkTypeCard'

export function checkIsTextPromptCard(card: CardActivityWithId | undefined, returnPrompt = false) {
  if (!card) return { is: false, text: '' }

  const { isMC, isRepeat, isRespond, isShortAnswer } = checkTypeCardActivity(card?.type)
  const hidePrompt = card?.hidePrompt === true

  if (returnPrompt) {
    if (isRepeat) {
      return {
        is: true,
        text: card?.target_text,
      }
    }

    if (isRespond) {
      return {
        is: true,
        text: card?.prompt,
      }
    }

    if (isMC) {
      return {
        is: true,
        text: card?.question,
      }
    }
  }

  if (isRepeat) {
    return {
      is: true,
      text: card?.target_text,
    }
  }

  if (isRespond && !hidePrompt) {
    return {
      is: true,
      text: card?.prompt,
    }
  }

  if (isMC) {
    return {
      is: true,
      text: card?.question,
    }
  }

  if (isShortAnswer && !hidePrompt) {
    return {
      is: true,
      text: card?.prompt,
    }
  }

  return {
    is: false,
    text: '',
  }
}
